let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7ppCQ")).then(() => parcelRequire('3BuQC'));